<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">{{ 'publicWifi.details.title' | translate }}</h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
<!--            <px-alert-->
<!--              *ngIf="hasError"-->
<!--              [alerts]="[-->
<!--                {-->
<!--                  type: 'error',-->
<!--                  description: 'publicWifi.pxsplus.howtoinstall.stale.error' | translate,-->
<!--                  isClosable: false-->
<!--                }-->
<!--              ]"-->
<!--            ></px-alert>-->
            <h2 class="rs-tit3">{{ 'publicWifi.pxsplus.howtoinstall.description' | translate }}</h2>
            <p>{{ 'publicWifi.pxsplus.howtoinstall.paragraph1' | translate }}</p>
            <h2 class="rs-tit3">
              {{ 'publicWifi.pxsplus.howtoinstall.howtoninstall' | translate }}
            </h2>
            <div class="row">
              <div class="columns small-12">
                <div class="rs-tmline" aria-label="Breadcrumb">
                  <ol class="rs-tmline-list">
                    <li class="rs-tmline-item rs-selected">
                      <div class="rs-tmline-indicator">
                        <div class="rs-tmline-indicator-el">
                          <span aria-label="Step 1 of 3"></span>
                          <span aria-hidden="true">1</span>
                        </div>
                      </div>
                      <div class="rs-tmline-title">
                        {{ 'publicWifi.pxsplus.howtoinstall.step1' | translate }}
                      </div>
                      <div
                        class="rs-tmline-content"
                        [innerHTML]="
                          'publicWifi.pxsplus.howtoinstall.step1.description' | translate: true
                        "
                      ></div>
                    </li>
                    <li class="rs-tmline-item rs-selected">
                      <div class="rs-tmline-indicator">
                        <div class="rs-tmline-indicator-el">
                          <span aria-label="Step 2 of 3"></span>
                          <span aria-hidden="true">2</span>
                        </div>
                      </div>
                      <div class="rs-tmline-title">
                        {{ 'publicWifi.pxsplus.howtoinstall.step2' | translate }}
                      </div>
                      <div
                        class="rs-tmline-content"
                        [innerHTML]="
                          'publicWifi.pxsplus.howtoinstall.step2.description' | translate: true
                        "
                      ></div>
                    </li>
                    <li class="rs-tmline-item rs-selected">
                      <div class="rs-tmline-indicator">
                        <div class="rs-tmline-indicator-el">
                          <span aria-label="Step 3 of 3"></span>
                          <span aria-hidden="true">3</span>
                        </div>
                      </div>
                      <div class="rs-tmline-title">
                        {{ 'publicWifi.pxsplus.howtoinstall.step3' | translate }}
                      </div>
                      <div
                        class="rs-tmline-content"
                        [innerHTML]="
                          'publicWifi.pxsplus.howtoinstall.step3.description' | translate: true
                        "
                      ></div>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="rs-me"></div>
            <a

              href="javascript:void(0)"
              class="rs-btn"
              onclick="window.ReactNativeWebView.postMessage('openAndroidInternetSettings')"
              >{{ 'publicWifi.pxsplus.howtoinstall.button' | translate }}
            </a>
          </div>

          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
